import dayjs from 'dayjs'
import { TomTableAdvancedFilterChipProps } from '../organisms/TomTableFilter'

export const retrieveUsedFilters = <T>(
  fieldsDefinition: TomTableAdvancedFilterChipProps<T>[],
  filter: T,
) => {
  const filtersInUse = fieldsDefinition.reduce<TomTableAdvancedFilterChipProps<T>[]>(
    (acc, fieldDefinition) => {
      if (!Object.prototype.hasOwnProperty.call(filter, fieldDefinition.propertyKey)) return acc

      const filterValue = filter[fieldDefinition.propertyKey as keyof T]

      if (!filterValue || (Array.isArray(filterValue) && filterValue.length === 0)) return acc

      fieldDefinition.value = filterValue

      acc.push(fieldDefinition)

      return acc
    },
    [],
  )

  return filtersInUse
}

export const clearFilterField = <T>(propertyKey: string, filter: T): void => {
  const key = propertyKey as keyof T
  filter[key] = null as any
}

export const formatDateTime = (date: any) => {
  if (!date) {
    return
  }

  return dayjs(date)
    .toDate()
    .toLocaleString([], { dateStyle: 'short', timeStyle: 'short', hour12: false })
}

export const formatDate = (date: any) => {
  if (!date) {
    return
  }

  return dayjs(date).toDate().toLocaleString([], { dateStyle: 'short' })
}

export const formatTime = (
  date: any,
  timeStyle: 'short' | 'full' | 'long' | 'medium' = 'short',
) => {
  if (!date) {
    return
  }

  return dayjs(date).toDate().toLocaleString([], { timeStyle: timeStyle, hour12: false })
}

export const formatDateRange = (dateRange: any) => {
  if (!dateRange?.[0] || !dateRange?.[1]) {
    return
  }

  const startDate = dayjs(dateRange[0])
  const endDate = dayjs(dateRange[1])

  if (!startDate.isValid() || !endDate.isValid()) return

  return `${formatDate(startDate)} - ${formatDate(endDate)}`
}
